import WorkoutBenefit from './WorkoutBenefit';

export default WorkoutBenefit;
